module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//green_1.png?v=f733f3df";